import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaShoppingCart } from "react-icons/fa";
import { HiArrowRight } from "react-icons/hi";

import BooKTable from "./BooKTable";
import Menu from "./Menu";
import AboutRestaurant from "./AboutRestaurant";
import { useQuery } from "@tanstack/react-query";
import {
  getAllOrders,
  getAllTableBookings,
} from "../../../../api/user/restaurants";
import Booking from "./TableBookings";
import Orders from "./Orders";
import { useAuth } from "../../../../context/AuthContext";
import Reviews from "./Reviews";
import { useTranslation } from "../../../../hooks/useTranslation";
import { getCart, getCartPrice } from "../../../../api/user/restaurants/cart";

const TabSelction = ({ restaurantId, restaurant, reservationId }) => {
  const { t } = useTranslation();
  const [activeTab1, setActiveTab1] = useState("Menu");
  const [page, setPage] = useState(1);
  const [ordersPage, setOrdersPage] = useState(1);
  const limit = 10;
  const [cartItems, setCartItems] = useState([]);
  const navigate = useNavigate();
  const { token } = useAuth();

  // Fetch cart data for checkout bar
  const { data: cartData, isLoading: isCartLoading } = useQuery({
    queryKey: ["cart"],
    queryFn: () => getCart(),
  });

  const cartRestaurantId = cartData?.data?.restaurantId || null;
  const cartItemsData = cartData?.data?.items || [];

  // Fetch cart price
  const { data: cartPriceData, isLoading: isCartPriceLoading } = useQuery({
    queryKey: ["cart-price-summary", cartItemsData?.length],
    queryFn: () => getCartPrice({}),
    enabled: !!cartItemsData?.length,
    keepPreviousData: true,
  });

  const charges = cartPriceData?.data?.charges || {};
  const totalItems = cartItemsData?.reduce((sum, item) => sum + (item.quantity || 0), 0) || 0;
  const showCheckoutBar = cartItemsData?.length > 0;

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["table-bookings", restaurantId, page],
    queryFn: () => getAllTableBookings({ page, limit, restaurantId }),
  });

  const {
    data: ordersData,
    isLoading: isOrdersLoading,
    isError: isOrdersError,
    error: ordersError,
  } = useQuery({
    queryKey: ["user-orders", restaurantId, ordersPage],
    queryFn: () => getAllOrders(restaurantId),
    enabled: !!restaurantId,
  });

  // const tabs = [
  //   { key: "Menu", label: "Menu" },
  //   { key: "Reviews", label: "Reviews" },
  //   {
  //     key: "About-Restaurant",
  //     label: "About Restaurant",
  //   },
  //   ...((token && !restaurant?.menuOnlyMode)
  //     ? [
  //       { key: "Book-a-Table", label: "Book a Table" },
  //       { key: "Table-Bookings", label: "Table Bookings" },
  //       { key: "Orders", label: "Orders" },
  //     ]
  //     : []),
  // ];

  let tabs;

  if (reservationId) {
    // Only show Menu tab
    tabs = [{ key: "Menu", label: t("aboutRestaurant").Menu }];
  } else {
    tabs = [
      { key: "Menu", label: t("aboutRestaurant").Menu },
      { key: "Reviews", label: t("aboutRestaurant").Reviews },
      { key: "About-Restaurant", label: t("aboutRestaurant").AboutRestaurant },
      ...(token && !restaurant?.menuOnlyMode
        ? [
          {
            key: "Book-a-Table",
            label: t("aboutRestaurant").BookaTable,
          },
          {
            key: "Table-Bookings",
            label: t("addrestaurant").tableBookings,
          },


        ]
        : []),
      { key: "Orders", label: t("aboutRestaurant").Orders },
    ];
  }



  return (
    <>
      <div className="flex flex-wrap gap-4 justify-between items-center py-[16px] border-y border-[#DDDDDD] md:mt-[0px] mt-5">
        <ul className="flex  sm:gap-[30px] gap-4 overflow-auto">
          {tabs.map((tab) => (
            <li key={tab.key}>
              <button
                className={`inline-flex items-center 2xl:text-lg text-base font-medium gap-[3px] py-[6] text-[#000] hover:text-[#4CAF50] whitespace-nowrap ${activeTab1 === tab.key
                  ? "!text-[#4CAF50]"
                  : "hover:text-[#4CAF50]"
                  }`}
                onClick={() => setActiveTab1(tab.key)}
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
        <div className="flex gap-[10px] items-center">
          {restaurant?.foodType === "veg" ? (
            <button className="py-[8px] px-[30px] leading-[30px] rounded-full sm:text-lg text-sm font-medium text-white bg-[#4CAF50]">
              {t("foodtype").veg}
            </button>
          ) : restaurant?.foodType === "non-veg" ? (
            <button className="py-[6px] px-[30px] leading-[30px] rounded-full sm:text-lg text-sm font-medium text-[#FF0000]  border border-[#FF0000]">
              {t("foodtype").nonVeg}
            </button>
          ) : (
            <>
              <button className="py-[8px] px-[30px] leading-[30px] rounded-full sm:text-lg text-sm font-medium text-white bg-[#4CAF50]">
                {t("foodtype").veg}
              </button>
              <button className="py-[6px] px-[30px] leading-[30px] rounded-full sm:text-lg text-sm font-medium text-[#FF0000]  border border-[#FF0000]">
                {t("foodtype").nonVeg}
              </button>
            </>
          )}
        </div>
      </div>

      {/* Tab Content */}
      <div className={`mt-[22px] ${showCheckoutBar ? 'pb-[120px] md:pb-[130px]' : ''}`}>
        {activeTab1 === "Menu" && (
          <div className="">
            <Menu
              restaurantId={restaurantId}
              menuOnlyMode={restaurant?.menuOnlyMode}
              reservationId={reservationId}
              cartItems={cartItems}
              setCartItems={setCartItems}
            />
          </div>
        )}
        {activeTab1 === "Reviews" && (
          <Reviews restaurantId={restaurantId}></Reviews>
        )}
        {activeTab1 === "About-Restaurant" && (
          <div className="">
            <AboutRestaurant restaurant={restaurant} />
          </div>
        )}
        {activeTab1 === "Book-a-Table" && (
          <div className="">
            <BooKTable restaurantId={restaurantId} restaurant={restaurant} />
          </div>
        )}
        {activeTab1 === "Table-Bookings" && (
          <div className="">
            <Booking
              isLoading={isLoading}
              isError={isError}
              error={error}
              reservations={data?.data?.reservations || []}
              pagination={data?.data?.pagination || {}}
              setPage={setPage}
            />
          </div>
        )}
        {activeTab1 === "Orders" && (
          <div className="">
            <Orders
              isLoading={isOrdersLoading}
              isError={isOrdersError}
              error={ordersError}
              reservations={ordersData?.data?.orders || []}
              pagination={ordersData?.data?.pagination || {}}
              setPage={setOrdersPage}
              afterReviewGo={() => setActiveTab1("Reviews")}
            />
          </div>
        )}
      </div>

      {/* Fixed Checkout Bar */}
      {showCheckoutBar && (
        <div className="fixed bottom-0 left-0 right-0 z-50 transform translate-y-0 transition-transform duration-300 ease-out">
          <div className="bg-white border-t-2 border-[#4CAF50] shadow-2xl rounded-t-[20px] md:rounded-t-[24px] backdrop-blur-sm">
            <div className="container">
              <div className="flex flex-col sm:flex-row items-center justify-between gap-4 py-5 px-4 md:py-6 md:px-6">
                {/* Left Section - Cart Info */}
                <div className="flex items-center gap-4 md:gap-6 w-full sm:w-auto">
                  {/* Cart Icon with Badge */}
                  <div className="relative">
                    <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-[#4CAF50]/10 flex items-center justify-center">
                      <FaShoppingCart className="text-[#4CAF50] text-xl md:text-2xl" />
                    </div>
                    {totalItems > 0 && (
                      <span className="absolute -top-1 -right-1 bg-[#FF6B6B] text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center shadow-md">
                        {totalItems > 9 ? '9+' : totalItems}
                      </span>
                    )}
                  </div>

                  {/* Price Info */}
                  <div className="flex flex-col">
                    {/* <p className="text-xs md:text-sm text-gray-500 font-medium uppercase tracking-wide">
                      {totalItems} {totalItems === 1 ? 'Item' : 'Items'} in cart
                    </p> */}
                    {!isCartPriceLoading && charges?.netAmount ? (
                      <div className="flex items-baseline gap-1">
                        <span className="text-lg md:text-xl font-bold text-[#4CAF50]">
                          ₾{charges.netAmount.toFixed(2)}
                        </span>
                        {charges?.discountAmount > 0 && (
                          <span className="text-xs text-gray-400 line-through">
                            ₾{(charges.netAmount + charges.discountAmount).toFixed(2)}
                          </span>
                        )}
                      </div>
                    ) : (
                      <div className="flex items-center gap-2">
                        <div className="w-4 h-4 border-2 border-[#4CAF50] border-t-transparent rounded-full animate-spin"></div>
                        <p className="text-sm font-medium text-gray-400">
                          Calculating...
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Right Section - Checkout Button */}
                <button
                  onClick={() =>
                    navigate(`/cart`, {
                      state: {
                        cartItems: cartItemsData,
                        restaurantId: cartRestaurantId || restaurantId,
                        reservationId,
                        menuOnlyMode: restaurant?.menuOnlyMode,
                      },
                    })
                  }
                  className="group relative w-full sm:w-auto px-8 md:px-10 py-3 md:py-4 rounded-full bg-gradient-to-r from-[#4CAF50] to-[#45a049] text-white font-semibold text-base md:text-lg shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all duration-300 flex items-center justify-center gap-2 overflow-hidden"
                >
                  {/* Button Background Effect */}
                  <span className="absolute inset-0 bg-gradient-to-r from-[#45a049] to-[#4CAF50] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                  
                  {/* Button Content */}
                  <span className="relative flex items-center gap-2">
                    <span>{t("restaurant").checkout}</span>
                    <HiArrowRight className="text-xl group-hover:translate-x-1 transition-transform duration-300" />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TabSelction;
